<template>
  <people url="people"></people>
</template>
<script>
import people from './components/people'
export default {
  components: {
    people
  }
}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/movie/people.vue